/* globals $, globalScene, allTweens, controller */
import { TimelineMax } from 'gsap';
import 'gsap/ScrollToPlugin';

import calculateOffset from 'helpers/calculateOffset';
import ScrollMagic from 'helpers/importers/ScrollMagic';

export default function cityScene (iconTimeline, callback) {
  let tweenStats = new TimelineMax()
  .from($('#stats h3'), 0.5, {
    yPercent: 120,
    opacity: 0,
  })
  .add(iconTimeline, '=-0.2');

  allTweens.push(tweenStats);

  let scenePictures = new ScrollMagic.Scene({
    triggerElement: '#pictures',
    offset: -calculateOffset(100),
    duration: 0,
    triggerHook: 'onEnter',
  }); //.addIndicators({name: "pictures"})

  let sceneStats = new ScrollMagic.Scene({
    triggerElement: '#stats',
    offset: 0,
    duration: 0,
    triggerHook: 'onCenter'
  }) //.addIndicators({name: "stats"})
  .setTween(tweenStats);

  scenePictures.on('start', _e => {
    callback();
  });

  scenePictures.enabled(false);
  sceneStats.enabled(false);

  scenePictures.addTo(controller);
  sceneStats.addTo(controller);

  globalScene.push(scenePictures);
  globalScene.push(sceneStats);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/cityScene.js